import script from "./LegalHubView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegalHubView.vue?vue&type=script&setup=true&lang=ts"

import "./LegalHubView.vue?vue&type=style&index=0&id=73290897&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73290897"]])

export default __exports__